import AlertAccent from '../../components/AlertAccent';
import BtnFilled from '../../components/BtnFilled';
import * as React from 'react';
import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { useUserStore } from '../../stores/use-user-store';
import { resendLinkVerification } from '../../api/api';
import useGetRole from '../../hooks/use-role';
import Modal from '../../components/Modal';

const AccountVerification = ({ showModal, setShowModal }) => {
  const { user } = useUserStore();
  const { isEngineer } = useGetRole();
  const sendVerificationLink = useCallback(async () => {
    const body = { email: user?.email, redirect_link: process.env.REACT_APP_REDIRECT_LINK + 'verify' };
    await resendLinkVerification(
      body,
      () => toast.success('На вашу почту была отправлена ссылка. Для подтверждения аккаунта перейдите по ней'),
      (err) => toast.error(err.error, { hideProgressBar: true })
    );
  }, [user?.email]);

  return (
    <Modal showModal={showModal} setShowModal={setShowModal} actionTitle="Отправить ссылку" closeCb={() => {}}>
      <AlertAccent
        title="Аккаунт не подтвержден!"
        text="Для подтверждения аккаунта перейдите, пожалуйста, по ссылке, отправленной на Вашу почту"
        showAlert={!user?.verified_at}></AlertAccent>
      {!isEngineer && <BtnFilled title="Отправить ссылку повторно" className={'max-w-fit flex m-auto mt-2'} btnCb={sendVerificationLink} />}
    </Modal>
  );
};

export default AccountVerification;
